import React, { useEffect } from 'react';
import { FaTools, FaUsersCog, FaClock, FaHandshake } from 'react-icons/fa';

function ServicesSection() {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.fade-in');
      elements.forEach(el => {
        const position = el.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if(position < windowHeight - 100){
          el.classList.add('visible');
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    { icon: <FaTools />, title: "تشطيبات احترافية", subtitle: "تنفيذ بأعلى جودة واحترافية" },
    { icon: <FaUsersCog />, title: "فريق متخصص", subtitle: "خبرة تمتد لسنوات عديدة" },
    { icon: <FaClock />, title: "دقة في المواعيد", subtitle: "التسليم في الوقت المحدد بدقة" },
    { icon: <FaHandshake />, title: "ثقة ومسؤولية", subtitle: "معايير شفافة وموثوقة" },
  ];

  return (
    <section className="services-section" style={{ backgroundColor: '#f7f4e3', padding: '80px 20px', direction:'rtl' }}>
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', textAlign:'center' }}>
        
        {/* نص القسم */}
        <p className='kha fade-in' style={{ fontSize:'24px', fontWeight:'500', lineHeight:'1.9', opacity:0, transform:'translateY(40px)', transition:'all 1s ease'}}>
          نحو مشاريع متميزة تجمع بين الإبداع والدقة<br/>
          معنا، كل مشروع قصة نجاح تُصنع باحتراف
        </p>

        {/* أيقونات الخدمات */}
        <div className="service-icons" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '40px',
          marginTop: '50px'
        }}>
          {services.map((item, index) => (
            <div key={index} className='fade-in card' style={{
              backgroundColor:'#fff',
              borderRadius:'20px',
              padding:'40px 25px',
              boxShadow:'0 12px 25px rgba(0,0,0,0.1)',
              transition:'all 0.3s ease',
              opacity:0,
              transform:'translateY(40px)',
              cursor:'default',
              position:'relative',
              overflow:'hidden'
            }}>
              {/* الخلفيات الذهبية الزخرفية المتحركة */}
              <div className="gold-circle gold-circle1"></div>
              <div className="gold-circle gold-circle2"></div>
              <div className="gold-line gold-line1"></div>
              <div className="gold-line gold-line2"></div>

              <div style={{ fontSize:'60px', color:'#C6A58C', marginBottom:'20px', position:'relative', zIndex:1 }} className='icon-hover'>
                {item.icon}
              </div>
              <h4 style={{ marginBottom:'12px', color:'#333', fontSize:'22px', position:'relative', zIndex:1 }}>{item.title}</h4>
              <p style={{ color:'#777', fontSize:'17px', lineHeight:'1.6', position:'relative', zIndex:1 }}>{item.subtitle}</p>
            </div>
          ))}
        </div>

      </div>

      {/* CSS داخلي للتأثيرات */}
      <style>{`
        .fade-in.visible {
          opacity:1 !important;
          transform:translateY(0) !important;
        }

        .icon-hover:hover {
          color:#f4c542 !important;
          transform: scale(1.4);
          transition: all 0.3s ease;
        }

        .card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 35px rgba(0,0,0,0.2);
        }

        /* الخلفيات الذهبية المتحركة */
        .gold-circle {
          position: absolute;
          border-radius: 50%;
          z-index: 0;
        }
        .gold-circle1 {
          width: 120px; height: 120px;
          top: -40px; right: -40px;
          background: radial-gradient(circle, rgba(246,223,158,0.3) 0%, rgba(246,223,158,0) 70%);
          transition: transform 0.5s ease;
        }
        .gold-circle2 {
          width: 70px; height: 70px;
          bottom: -30px; left: -30px;
          background: radial-gradient(circle, rgba(246,223,158,0.2) 0%, rgba(246,223,158,0) 70%);
          transition: transform 0.5s ease;
        }
        .gold-line {
          position: absolute;
          height: 2px;
          background: linear-gradient(to right, rgba(246,223,158,0.3), rgba(246,223,158,0));
          z-index: 0;
          transition: transform 0.5s ease;
        }
        .gold-line1 {
          width: 140px;
          top: 25%;
          left: -50px;
          transform: rotate(-20deg);
        }
        .gold-line2 {
          width: 100px;
          bottom: 35%;
          right: -40px;
          transform: rotate(15deg);
        }

        .card:hover .gold-circle1 {
          transform: translate(-12px, 12px) rotate(8deg);
        }
        .card:hover .gold-circle2 {
          transform: translate(8px, -8px) rotate(-8deg);
        }
        .card:hover .gold-line1 {
          transform: rotate(-18deg) translate(8px, -4px);
        }
        .card:hover .gold-line2 {
          transform: rotate(22deg) translate(-6px, 4px);
        }

        @media (max-width: 768px){
          .service-icons {
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          }
          p.kha {
            font-size: 18px !important;
          }
          h4 {
            font-size: 20px !important;
          }
          .icon-hover {
            font-size: 50px !important;
          }
        }
      `}</style>
    </section>
  );
}

export default ServicesSection;
